/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Permissions_FullInputs */

const vi_api_keys_permissions_full = /** @type {(inputs: Api_Keys_Permissions_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn quyền (khoá cũ)`)
};

/**

* @param {Api_Keys_Permissions_FullInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permissions_full = /** @type {((inputs?: Api_Keys_Permissions_FullInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Permissions_FullInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permissions_full(inputs)
});